import React, { useState } from "react";
import { Calendar } from "primereact/calendar";
import moment from "moment";

export default function CalendarComp({sx,sxCal,name, value,canlenderFilter,view,range=true, handleFilter,...restProps}) {
  const [dates, setDates] = useState(null);
  const handleDateRange = (e,name) => {
    setDates(e.value);
    // console.log("e.value",Array.isArray(e.value));
    
    const formattedDates = Array.isArray(e.value)? e.value?.map(date => moment(date).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")):moment(e.value).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
    formattedDates && formattedDates[1]!=="Invalid date"&& handleFilter(name, formattedDates);
    // console.log('formattedDates',formattedDates);

    switch (view) {
      case 'year':
        const start = moment(e.value).startOf('year').format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
        const end = moment(e.value).endOf('year').format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
        handleFilter(view||name,[start,end])        
        break;
      case 'month':
        const startDate = moment(e.value).startOf('month').format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
        const endDate = moment(e.value).endOf('month').format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
        handleFilter(view||name,[startDate,endDate])        
        break;
      case 'week':      

        handleFilter(view||name,value)
        break;    
      default:
        handleFilter(view||name,formattedDates)
        break;
    }
    
  };
  return (
    <div  style={sx?sx:{}} className="card flex justify-content-center">
      <Calendar
        placeholder="    Select Dates"
        value={dates}
        onChange={(e) => handleDateRange(e,canlenderFilter?canlenderFilter.inputName:"month_range")}
        selectionMode={range?"range":'single'}      
        maxDate={canlenderFilter && canlenderFilter.maxDate?canlenderFilter.maxDate:null}
        view={view||'date'}
        // readOnlyInput


  
        {...restProps}
        // hideOnRangeSelection
        // touchUI 
          style={sxCal?sxCal:{}}
      />
    </div>
  );
}
